import "../styles/settings.css";
export default function Settings() {
  const mockSettings = {
    companyName: "FastFood Express",
    companyAddress: "123 Main Street",
    defaultBranch: "Main Branch",
    taxRate: 7.5, // %
    currency: "USD",
    notifications: true,
  };

  return (
    <>
      <h1>Setting</h1>
      <div className="settings-grid">
        <div className="setting-item">
          <p className="label">Company Name</p>
          <p className="value">{mockSettings.companyName}</p>
        </div>

        <div className="setting-item">
          <p className="label">Company Address</p>
          <p className="value">{mockSettings.companyAddress}</p>
        </div>

        <div className="setting-item">
          <p className="label">Default Branch</p>
          <p className="value">{mockSettings.defaultBranch}</p>
        </div>

        <div className="setting-item">
          <p className="label">Tax Rate</p>
          <p className="value">{mockSettings.taxRate}%</p>
        </div>

        <div className="setting-item">
          <p className="label">Currency</p>
          <p className="value">{mockSettings.currency}</p>
        </div>

        <div className="setting-item">
          <p className="label">Notifications</p>
          <p className="value">{mockSettings.notifications ? "On" : "Off"}</p>
        </div>
      </div>
    </>
  );
}
